import { render, staticRenderFns } from "./contact_info.vue?vue&type=template&id=12342c1e&scoped=true"
import script from "./contact_info.vue?vue&type=script&lang=js"
export * from "./contact_info.vue?vue&type=script&lang=js"
import style0 from "./contact_info.vue?vue&type=style&index=0&id=12342c1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12342c1e",
  null
  
)

export default component.exports